import React from "react";

import {
  CardBody,
  CardContainer,
  CardItem,
} from "./ui/3d-card";

import {
  IconArrowUpRight,
  IconCode,
  IconSparkles,
} from "@tabler/icons-react";


export default function ThreeDCardDemo() {

  return (

    <CardContainer
      containerClassName="
        w-full
        py-8
        sm:py-10
      "
      className="
        w-full
        max-w-[520px]
      "
    >

      <CardBody
        className="
          group/card
          relative
          h-auto
          w-full
          rounded-[24px]
          border
          border-white/10
          bg-[#111111]/90
          p-5
          shadow-2xl
          shadow-black/30
          backdrop-blur-xl
          sm:p-7
        "
      >

        {/* TOP LABEL */}

        <CardItem
          translateZ={40}
          className="
            flex
            items-center
            gap-2
            text-[10px]
            font-bold
            uppercase
            tracking-[0.2em]
            text-[#55aef3]
          "
        >

          <IconSparkles size={15} />

          WE3X Interactive Experience

        </CardItem>


        {/* HEADING */}

        <CardItem
          translateZ={65}
          className="
            merriweather
            mt-5
            max-w-md
            text-2xl
            font-black
            leading-tight
            text-white
            sm:text-3xl
          "
        >

          Websites that don't
          just sit there.

          <span
            className="
              block
              text-[#55aef3]
            "
          >
            They respond.
          </span>

        </CardItem>


        {/* DESCRIPTION */}

        <CardItem
          as="p"
          translateZ={80}
          className="
            mt-4
            max-w-md
            text-sm
            leading-7
            text-white/45
          "
        >

          Move your cursor across this experience
          and watch every layer react in depth.

        </CardItem>


        {/* 3D VISUAL */}

        <CardItem
          translateZ={110}
          className="
            mt-6
            w-full
          "
        >

          <div
            className="
              relative
              h-[220px]
              w-full
              overflow-hidden
              rounded-[18px]
              border
              border-white/10
              bg-[#080808]
              sm:h-[260px]
            "
          >

            {/* GRID */}

            <div
              className="
                pointer-events-none
                absolute
                inset-0
                opacity-[0.12]
              "
              style={{

                backgroundImage:
                  "linear-gradient(rgba(255,255,255,.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.3) 1px, transparent 1px)",

                backgroundSize:
                  "28px 28px",

              }}
            />


            {/* BLUE GLOW */}

            <div
              className="
                absolute
                left-1/2
                top-1/2
                h-[220px]
                w-[220px]
                -translate-x-1/2
                -translate-y-1/2
                rounded-full
                bg-[#55aef3]/20
                blur-[70px]
              "
            />


            {/* CENTER UI */}

            <div
              className="
                relative
                z-10
                flex
                h-full
                items-center
                justify-center
              "
            >

              <div
                className="
                  rounded-[18px]
                  border
                  border-[#55aef3]/30
                  bg-white/[0.05]
                  p-7
                  text-center
                  backdrop-blur
                "
              >

                <IconCode
                  size={32}
                  className="
                    mx-auto
                    text-[#55aef3]
                  "
                />


                <p
                  className="
                    mt-4
                    text-xs
                    font-bold
                    uppercase
                    tracking-[0.17em]
                    text-white
                  "
                >
                  Interactive Web
                </p>


                <p
                  className="
                    mt-2
                    text-[11px]
                    text-white/35
                  "
                >
                  Move · Hover · Experience
                </p>

              </div>

            </div>

          </div>

        </CardItem>


        {/* BOTTOM */}

        <div
          className="
            mt-7
            flex
            items-center
            justify-between
            gap-4
          "
        >

          <CardItem
            translateZ={30}
            className="
              text-xs
              font-medium
              text-white/40
            "
          >
            Built by WE3X
          </CardItem>


          <CardItem
            translateZ={45}
          >

            <a
              href="/contact"
              className="
                group
                inline-flex
                items-center
                gap-2
                rounded-xl
                bg-[#55aef3]
                px-5
                py-3
                text-xs
                font-bold
                text-white
                transition-colors
                hover:bg-white
                hover:text-black
              "
            >

              Build yours

              <IconArrowUpRight
                size={15}
                className="
                  transition-transform
                  group-hover:translate-x-1
                  group-hover:-translate-y-1
                "
              />

            </a>

          </CardItem>

        </div>

      </CardBody>

    </CardContainer>

  );

}